import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-session-expiring-dialog',
  templateUrl: './session-expiring-dialog.component.html',
  styleUrls: ['./session-expiring-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule]
})
export class SessionExpiringDialogComponent implements OnInit, OnDestroy {
  protected countdownDisplay: string = '';
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly logoutDeadline: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: SessionExpiringDialogData,
    private readonly dialogRef: MatDialogRef<SessionExpiringDialogComponent>) {
    this.logoutDeadline = data.logoutDeadline;
    }

  ngOnInit(): void {
    this.tick(); 
    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  private tick(): void {
    const remainingMs = this.logoutDeadline - Date.now();
    const remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    this.countdownDisplay = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    if (remainingSeconds <= 0) {
      this.dialogRef.close('timeout');
    }
  }

  protected onStaySignedIn(): void {
    this.dialogRef.close('stay');
  }

  protected onSignOutNow(): void {
    this.dialogRef.close('signout');
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
}
export interface SessionExpiringDialogData {
    logoutDeadline: number;
}
